import React from 'react';
import './EventDetails.css';

const EventDetails = () => {
  return (
    <section id="event-details" className="event-details">
      <div className="container">
        <h2>Event Details</h2>
        <p className="event-details-subtitle">
          Everything you need to know about iBUILD 2025
        </p>
        
        <div className="details-grid">
          <div className="detail-card">
            <div className="detail-icon">📅</div>
            <h3>Date</h3>
            <p>13th December, 2025</p>
          </div>
          
          <div className="detail-card">
            <div className="detail-icon">📍</div>
            <h3>Location</h3>
            <p>Gold Rush Suites</p>
            <small>14 Ezimgbu Link Road, GRA, Port Harcourt 500101, Rivers</small>
          </div>
          
          <div className="detail-card">
            <div className="detail-icon">🕓</div>
            <h3>Time</h3>
            <p>12:00 PM – 8:00 PM</p>
            <small>Full day experience</small>
          </div>
          
          <div className="detail-card">
            <div className="detail-icon">🎫</div>
            <h3>Cost</h3>
            <p>Free Event</p>
            <small>No payment required</small>
          </div>
        </div>
        
        <div className="location-map">
          <h3>Find Us</h3>
          <div className="map-container">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d235.53809243383697!2d7.011207!3d4.8255941!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1069cdd75bb6d34d%3A0x4c978a92f164eff8!2sGold%20Rush%20Suites!5e1!3m2!1sen!2sng!4v1765443036622!5m2!1sen!2sng" 
              width="100%" 
              height="450" 
              style={{border: 0}} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="Gold Rush Suites Location"
            ></iframe>
          </div>
        </div>
        
        <div className="schedule-preview">
          <h3>Schedule Preview</h3>
          <div className="schedule-timeline">
            <div className="timeline-item">
              <div className="timeline-content">
                <h4>Registration & Welcome</h4>
                <p>Check-in and networking</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-content">
                <h4>Opening Keynote</h4>
                <p>Setting the stage for the Builder's Evolution</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-content">
                <h4>Panel Discussions</h4>
                <p>Deep dives into building sustainable companies</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-content">
                <h4>Startup Pitches</h4>
                <p>Founders showcase their innovations</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-content">
                <h4>Workshops & Breakouts</h4>
                <p>Hands-on learning sessions</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-content">
                <h4>Evening Mixer</h4>
                <p>Networking, drinks, and collaboration</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventDetails;
